import Btn from "@/components/Btn";
import { EmailInputWithValidation } from "@/components/EmailInputWithValidation";
import { IForgotPassword } from "@/interfaces/auth.interface";
import authService from "@/services/auth.service";
import { EMAIL_VALIDATOR } from "@/utils/common";
import ToastService from "@/utils/toast";
import {
  Field,
  FieldWrapper,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { ChevronLeft } from "lucide-react";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const ForgotPasswordForm = () => {
  const [forgotPassword] = React.useState<IForgotPassword>({
    email: "",
  });

  const navigateTo = useNavigate();

  const handleSubmit = (dataItem: { [name: string]: any }) => {
    authService
      .forgotPassword(dataItem.email)
      .then((response: any) => {
        if (!response.error) {
          navigateTo(`/recover-email?email=${dataItem.email}`);
        } else {
          ToastService.error(response.error);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="w-full">
      <div className="mb-4">
        <Link to="/">
          <button className="p-0 text-[#A3AED0]">
            <span className="inline-flex items-center">
              <ChevronLeft className="w-4 h-4 text-[#A3AED0]" />{" "}
              <span className="ml-1 text-[#A3AED0] font-cabin font-medium">
                Go Back
              </span>
            </span>
          </button>
        </Link>
      </div>

      <h3 className="text-[27px] cabin-500 text-[#2B3674] font-bold">
        Recover your Password
      </h3>
      <p className="text-[#A3AED0] text-[12px]">
        Enter your email to continue!
      </p>
      <div className="mt-5">
        <Form
          initialValues={forgotPassword}
          onSubmit={handleSubmit}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement className="mb-4">
              <fieldset className={"k-form-fieldset"}>
                <FieldWrapper>
                  <div className="k-form-field-wrap">
                    <div className="relative loginField">
                      <Field
                        name={"email"}
                        type={"email"}
                        component={EmailInputWithValidation}
                        label={"Email*"}
                        placeholder={"mail@alec.ae"}
                        labelClassName="font-cabin font-medium mb-2 text-[var(--kendo-neutral-160)]"
                        validator={EMAIL_VALIDATOR}
                      />
                    </div>
                  </div>
                </FieldWrapper>
              </fieldset>

              <div className="k-form-buttons">
                <Btn
                  variant="primary"
                  text={"Continue"}
                  disabled={!formRenderProps.allowSubmit}
                  onClick={() => {}}
                />
              </div>
            </FormElement>
          )}
        />
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
